<template>
  <v-dialog v-model="activateDialog" persistent max-width="700">
    <v-card :loading="loading" loader-height="2">
      <v-toolbar dense flat>
        <v-toolbar-title>
          activate {{ myData.salute }} {{ myData.first_name }}
          {{ myData.last_name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch
          dense
          inset
          style="width: 150px; margin: 22px 0 0 0"
          v-model="entry.verified"
          :label="`Activate:   ${entry.verified ? ' Yes' : ' No'}`"
        ></v-switch>
      </v-toolbar>

      <v-divider />
      <v-card-text>
        <v-list subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="capitalize"
                >subscriber type
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ myData.subscriber_type }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="capitalize"
                >specialization
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ myData.specialization }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="capitalize"
                >specialization detail
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ myData.specialization_detail }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="capitalize"
                >professional name
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ myData.professional_name }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="capitalize"
                >registration number
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ myData.registration_number }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="capitalize"
                >profession expiry
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ myData.profession_expiry }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="red" v-on="on" @click="closeDialog">
              cancel
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="blue" v-on="on" @click="submit">
              yes
            </v-btn>
          </template>
          <span>Submit</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import Restful from "@/services/RestFul";
import Utils from "@/mixins/utils.js";

export default {
  props: {
    activateDialog: Boolean,
    id: { type: Number, default: 0 },
    myData: { type: Object, default: null },
  },
  mixins: [Utils],
  data() {
    return {
      responseMessage: null,
      loading: false,
      entry: {
        verified: true,
      },
    };
  },
  watch: {
    verify: function (a) {
      this.entry.verified = a;
    },
  },
  created() {
    this.entry.verified = this.myData.verify;
  },
  methods: {
    closeDialog() {
      let payload = { id: this.id, state: false };
      this.$emit("closeAct", payload);
    },
    submit() {
      let verified = this.entry.verified;
      let active = this.entry.verified;
      let data = { verified, active };

      let payload = { id: this.id, state: false, data: data };
      this.$emit("submitAct", payload);
    },
  },
};
</script>
